import Model from '@/Models/Contracts/Model';
export default class User extends Model {
    resource() {
        return 'users';
    }
    get isAdmin() {
        var _a;
        return (_a = this.is_admin) !== null && _a !== void 0 ? _a : false;
    }
    get isDeveloper() {
        var _a;
        return (_a = this.is_developer) !== null && _a !== void 0 ? _a : false;
    }
}
